import { useMediaQuery } from "@material-ui/core";
import { MOBILE_BREAKPOINT } from "../../config";

export const useMobileMediaQuery = () => useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT}px)`, { noSsr: true });
